import { AxiosResponse } from 'axios';
import { Objeto } from '../../Models';
import Context from '../../context';

class SoftwareExterno {
    /* #region  GET Controller  */
    /* #endregion */

    /* #region  POST Controller  */
    /* Sobre esta função *//**
     * Vincula o usuario local ao usuário no software externo
     * @param {string} Token Informe o token de acesso do usuário obtido ao executar a requisição "/Logon/{CPF}/{Senha}"
     * @param {number} Empresa Informe o código da empresa (id). A lista das empresas cadastradas poderá ser obtida ao executar a requisição "/Empresa/{Token}"
     * @param {string} CentroDeCusto Informe a sigla que identifica o centro de custo. A lista dos centros de custos cadastrados poderá ser obtido ao executar a requisição "/CentroDeCusto/{Token}/{Empresa}"
     * @param {string} TokenSoftwareExterno Informe o token do software externo (token). A lista das tokens cadastrados poderá ser obtida ao executar a requisição "/SoftwareExterno/BancoDeDados/{Token}"
     * @param {number} Pessoa Informe o código da pessoa (Id). Esta pessoa deverá estar cadastrada como um usuário do sistema!
     * @param {string} PessoaVinculada Informe o código da pessoa no software externo
     **/
    public async NovoUsuarioExterno(Token: string, Empresa: number, CentroDeCusto: string, TokenSoftwareExterno: string, Pessoa: number, PessoaVinculada: string): Promise<AxiosResponse<any>> {
        return await Context.post(`/SoftwareExterno/NovoUsuarioExterno/${Token}/${Empresa}/${CentroDeCusto}/${TokenSoftwareExterno}/${Pessoa}/${PessoaVinculada}`)
            .then((Response) => { return Response; })
            .catch((Exception) => { return Exception; });
    };
    /* #endregion */

    /* #region  DELETE Controller  */
    /* #endregion */

    /* #region  PUT Controller  */
    /* #endregion */
};

export default new SoftwareExterno();